import { render, staticRenderFns } from "./MspRicollegaGarmin.vue?vue&type=template&id=8c782710"
import script from "./MspRicollegaGarmin.vue?vue&type=script&lang=js"
export * from "./MspRicollegaGarmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports